export default {
    triggerGlobalSnackbar({ commit }, payload) {
        commit('setGlobalSnackbar', payload);
    }
}